export default __webpack_public_path__ + "static/media/all_notes.004bce17.png";